import { IntlShape, useIntl } from 'react-intl';
import { connectEventsVM } from '../events.context';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { ManageEventViewModel } from './manage-event.viewmodel';
import { ManageEventPresentation } from './manage-event.presentation';

interface IContainerProps {
    eventId: number;
    accountId: number;
    intl: IntlShape;
}

const ManageEventContainer = withViewModel(
    ManageEventPresentation,
    (props: IContainerProps) => {
        const manageEventVM = new ManageEventViewModel(props.eventId, props.accountId, props.intl);
        manageEventVM.initialize();
        return manageEventVM;
    },
    props => [props.eventId, props.accountId],
    vm => vm.shutdown(),
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Readonly array(IAccountDetailsDTO.allowedProviders) can't be assigned to mutable array
// because of absence of array methods which we actually don't need
// (https://stackoverflow.com/questions/62225769/inconsistency-with-typescript-readonly-type)
const ManageEventConnected = connectEventsVM<IContainerProps>(ManageEventContainer, vm => {
    const intl = useIntl();

    return {
        accountId: vm.getAccountId(),
        eventId: vm.getEventId(),
        intl: intl
    };
});

export { ManageEventConnected as ManageEvent };
